import { RemuneracaoMedica } from '@/types/core'
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'

@Module({ namespaced: true, name: 'CalculoTetoStore' })
export default class CalculoTetoStore extends VuexModule {
  remuneracaoMedica: RemuneracaoMedica.IPrestadorRecebimento = new RemuneracaoMedica.PrestadorRecebimento()

  public pagina: number = 1
  public qtdPorPagina: number = 50
  public listaTeto: any[] = []
  selectedRegra: string = ''
  selectedMesReferencia: string = ''
  showSuccessScreen: boolean = false
  showErrorScreen: boolean = false
  successList: any = {}
  errorMessage: string = ''

  headers: any[] = [
    { text: 'Fonte pagadora', value: 'fontePagadoraNome', sortable: false },
    { text: 'Status repasse', value: 'statusRepasse', sortable: false },
    { text: 'Valor total', value: 'valorTotalRepasse', sortable: false },
  ]

  @Mutation
  setListaTeto(listaTeto: any[]) {
    this.listaTeto = listaTeto
  }

  @Mutation
  setSelectedMesReferencia(mesReferencia: string) {
    this.selectedMesReferencia = mesReferencia
  }

  @Mutation
  setSelectedRegra(value: string) {
    this.selectedRegra = value
  }

  @Mutation
  setShowSuccessScreen(showSuccessScreen: boolean) {
    this.showSuccessScreen = showSuccessScreen
  }

  @Mutation
  setShowErrorScreen(showErrorScreen: boolean) {
    this.showErrorScreen = showErrorScreen
  }

  @Mutation
  setSuccessList(successList: any) {
    this.successList = successList
  }

  @Mutation
  setErrorMessage(errorMessage: string) {
    this.errorMessage = errorMessage
  }

  @Action
  async getListaTeto() {
    try {
      const response = await this.remuneracaoMedica.getListaTeto()
      if (response.success) {
        this.context.commit('setListaTeto', response.data.itens)
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getPreviaTeto() {
    try {
      const params: any = {
        regraCalculoTetoGlobalId: this.selectedRegra,
        mesAnoCompetencia: this.selectedMesReferencia ? `${this.selectedMesReferencia}-01` : null,
      }
      const response = await this.remuneracaoMedica.getPreviaTeto(params)
      if (response.success) {
        this.context.commit('setShowErrorScreen', false)
        this.context.commit('setErrorMessage', [])
        this.context.commit('setShowSuccessScreen', true)
        this.context.commit('setSuccessList', response.data) 
      } else {
        this.context.commit('setShowSuccessScreen', false)
        this.context.commit('setSuccessList', {})
        this.context.commit('setShowErrorScreen', true)
        this.context.commit('setErrorMessage', response.message || [])
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async calcularTeto() {
    try {
      const params: any = {
        mesAnoCompetencia: this.selectedMesReferencia ? `${this.selectedMesReferencia}-01` : null,
        regraCalculoTetoGlobalId: this.selectedRegra,
      }
      const response = await this.remuneracaoMedica.calcularTeto(params)
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }
}
